import React, { FC, memo } from 'react'
import { get, Box, Spinner } from '@ally/metronome-ui'
import styled from 'styled-components'

interface TableProps {
  isLoading: boolean
  data: any[]
  lastRow?: any | undefined
}
const StyledSpinner = styled(Spinner)`
  margin: auto;
`
const StyledCard = styled('div')`
  background: ${get.colors('white')};
  color: ${get.colors('slate-5')};
  display: grid;
  padding: ${get.space('sm')};
  justify-items: center;
`
const CardList = styled('ol')`
  background: ${get.colors('white')};
  color: ${get.colors('slate-5')};
  display: grid;
  padding: 0;
`

const Card = styled('li')`
  background: ${get.colors('white')};
  color: ${get.colors('slate-5')};
  display: grid;
  padding: ${get.space('sm')};
  border: 1px solid ${get.colors('slate-1')};
  text-align: left;
`

const LastRowCard = styled('li')`
  text-align: center;
  list-style: none;
`

const CardListWrapper = styled(Box).attrs({
  mb: 'xs',
})`
  .styled-alert {
    border-bottom: solid 1px ${get.colors('gray-300')};
    padding: ${get.space('sm')};
  }

  .empty-message {
    border-bottom: solid 1px ${get.colors('gray-300')};
    padding: ${get.space('sm')};
  }
  background-color: ${get.colors('white')};
  text-align: center;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 0 0 0 1px ${get.colors('gray-300')},
    0 2px 4px -2px rgba(0, 0, 0, 0.16), 0 5px 8px -4px rgba(0, 0, 0, 0.16);
`
const LoadingCard: FC = () => {
  return (
    <StyledCard>
      <StyledSpinner size="small" />
    </StyledCard>
  )
}
export const MobileCardList: FC<TableProps> = memo(
  ({ data, isLoading, lastRow }) => {
    return (
      <CardListWrapper data-testid="mobileCardList">
        {!isLoading ? (
          <CardList>
            {!!data.length &&
              data.map((element, i) => {
                // eslint-disable-next-line react/no-array-index-key
                return <Card key={i}>{element}</Card>
              })}
            {lastRow && <LastRowCard>{lastRow}</LastRowCard>}
          </CardList>
        ) : (
          <LoadingCard />
        )}
      </CardListWrapper>
    )
  },
)
